export default "__VITE_ASSET__Dg2dy5lX__"